import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import styles from './EfesContentHeader.module.scss';

const EfesContentHeader = ({ headerText, headerImage, imageWidth }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.efesHeader}>
      <div className={styles.menuItem}>
        <div className={styles.imgDiv}>
          <img
            src={headerImage}
            alt="Header"
            style={{ width: imageWidth }}
          />
        </div>
        <div className={styles.textDiv}>
          <div className={styles.text}>{t(headerText)}</div>
        </div>
      </div>
    </div>
  );
};

EfesContentHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
  headerImage: PropTypes.string.isRequired,
  imageWidth: PropTypes.number,
};

EfesContentHeader.defaultProps = {
  imageWidth: 70,
};

export default EfesContentHeader;
